export default {
  padding: {
    padding: '15px',
  },
  keys: {
    fontWeight: 500,
  },
};
